import { Footer, Header, RouterContext, TripleAction } from '../../gs-component-right-rail';
import { FormikProps } from 'formik';
import React, { useContext } from 'react';

import { ApiClientsContext } from '../components/ApiClientsContext';
import { useBookingsAddress } from '../helpers/useBookingsAddress';
import { Content } from './Content';
import { SoEInitialValues } from './ScheduleOfEventsForm';
import { AutoFocusableFields } from './interface';

interface Props {
  formProps: FormikProps<SoEInitialValues>;
  isNew: boolean;
  hasWWS: boolean;
  loading: boolean;
  setClose: (val: boolean) => void;
  autoFocusField: AutoFocusableFields | undefined;
  isExperiment?: boolean;
  preview?: boolean;
}

export const MainScreen: React.FC<Props> = ({
  formProps,
  isNew,
  loading,
  hasWWS,
  setClose,
  autoFocusField,
  isExperiment,
  preview,
}) => {
  const { push } = useContext(RouterContext);
  const { eventType } = useContext(ApiClientsContext);
  useBookingsAddress({
    setFieldValue: formProps.setFieldValue,
    values: formProps.values,
  });

  const onRailClose = (): void => {
    if (formProps.dirty) {
      push('confirmation');
    } else {
      setClose(false);
      formProps.resetForm();
    }
  };

  const removeEvent = (): void => push('deleteConfirmation');

  return (
    <>
      <Header
        onClose={!preview ? onRailClose : undefined}
        leftButtonOnClick={onRailClose}
        leftButtonText={preview ? 'Back' : ''}
        as="h1"
      >
        {`${isNew ? 'Add' : 'Edit'} Event`}
      </Header>
      <Content formProps={formProps} hasWWS={hasWWS} autoFocusField={autoFocusField} isExperiment={isExperiment} />
      <Footer>
        <TripleAction
          primaryText="Save"
          primaryOnClick={formProps.submitForm}
          primaryDisabled={loading}
          secondaryText="Cancel"
          secondaryOnClick={onRailClose}
          tertiaryText={!isNew && eventType !== 'WeddingDay' ? 'Remove Event' : undefined}
          tertiaryOnClick={removeEvent}
        />
      </Footer>
    </>
  );
};
